import { 
  SystemUser, 
  AuditLog, 
  SystemConfiguration, 
  DataIntegration, 
  SecurityPolicy, 
  SystemHealth, 
  BackupConfiguration, 
  ComplianceReport 
} from '../types';

export const mockSystemUsers: SystemUser[] = [
  {
    id: 'USR001',
    email: 'sarah.chen@cloudsonmars.com',
    name: 'Sarah Chen',
    role: 'HR_LEADER',
    department: 'Human Resources',
    status: 'ACTIVE',
    lastLogin: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    createdAt: '2023-01-15T10:00:00Z',
    permissions: ['VIEW_ALL', 'EDIT_ALL', 'DELETE', 'EXPORT', 'ADMIN'],
    mfaEnabled: true,
    apiAccess: true,
    dataAccess: {
      departments: ['all'],
      regions: ['all'],
      sensitiveData: true
    }
  },
  {
    id: 'USR002',
    email: 'michael.brown@cloudsonmars.com',
    name: 'Michael Brown',
    role: 'MANAGER',
    department: 'Engineering',
    status: 'ACTIVE',
    lastLogin: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
    createdAt: '2023-03-20T14:30:00Z',
    permissions: ['VIEW_TEAM', 'EDIT_TEAM', 'EXPORT_LIMITED'],
    mfaEnabled: true,
    apiAccess: false,
    dataAccess: {
      departments: ['Engineering'],
      regions: ['EU'],
      sensitiveData: false
    }
  },
  {
    id: 'USR003',
    email: 'alex.johnson@cloudsonmars.com',
    name: 'Alex Johnson',
    role: 'RECRUITER',
    department: 'Talent Acquisition',
    status: 'ACTIVE',
    lastLogin: new Date(Date.now() - 1 * 60 * 60 * 1000).toISOString(),
    createdAt: '2023-02-10T09:15:00Z',
    permissions: ['VIEW_CANDIDATES', 'EDIT_REQUISITIONS', 'EXPORT', 'MARKET_INTELLIGENCE'],
    mfaEnabled: true,
    apiAccess: true,
    dataAccess: {
      departments: ['all'],
      regions: ['EU', 'US'],
      sensitiveData: false
    }
  },
  {
    id: 'USR004',
    email: 'lisa.wang@cloudsonmars.com',
    name: 'Lisa Wang',
    role: 'HR_LEADER',
    department: 'People Analytics',
    status: 'ACTIVE',
    lastLogin: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString(),
    createdAt: '2022-11-05T11:20:00Z',
    permissions: ['VIEW_ALL', 'EDIT_ALL', 'DELETE', 'EXPORT', 'ADMIN', 'SYSTEM_CONFIG'],
    mfaEnabled: true,
    apiAccess: true,
    dataAccess: {
      departments: ['all'],
      regions: ['all'],
      sensitiveData: true
    }
  },
  {
    id: 'USR005',
    email: 'david.kim@cloudsonmars.com',
    name: 'David Kim',
    role: 'MANAGER',
    department: 'Product',
    status: 'SUSPENDED',
    lastLogin: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
    createdAt: '2023-04-01T13:45:00Z',
    permissions: ['VIEW_TEAM'],
    mfaEnabled: false,
    apiAccess: false,
    dataAccess: {
      departments: ['Product'],
      regions: ['US'],
      sensitiveData: false
    }
  },
  {
    id: 'USR006',
    email: 'emma.wilson@cloudsonmars.com',
    name: 'Emma Wilson',
    role: 'HR_LEADER',
    department: 'Human Resources',
    status: 'PENDING',
    lastLogin: '',
    createdAt: new Date().toISOString(),
    permissions: ['VIEW_ALL', 'EDIT_ALL'],
    mfaEnabled: false,
    apiAccess: false,
    dataAccess: {
      departments: ['all'],
      regions: ['EU'],
      sensitiveData: true
    }
  }
];

export const mockAuditLogs: AuditLog[] = [
  {
    id: 'LOG001',
    timestamp: new Date(Date.now() - 5 * 60 * 1000).toISOString(),
    userId: 'USR001',
    userName: 'Sarah Chen',
    action: 'User Role Updated',
    category: 'USER_MANAGEMENT',
    details: 'Changed role from MANAGER to HR_LEADER for user Emma Wilson',
    ipAddress: '192.168.1.42',
    userAgent: 'Chrome/120.0.0.0',
    status: 'SUCCESS',
    affectedEntity: 'USR006'
  },
  {
    id: 'LOG002',
    timestamp: new Date(Date.now() - 15 * 60 * 1000).toISOString(),
    userId: 'USR003',
    userName: 'Alex Johnson',
    action: 'Export Candidate Data',
    category: 'DATA_ACCESS',
    details: 'Exported 245 candidate records to CSV format',
    ipAddress: '192.168.1.38',
    userAgent: 'Chrome/120.0.0.0',
    status: 'SUCCESS'
  },
  {
    id: 'LOG003',
    timestamp: new Date(Date.now() - 30 * 60 * 1000).toISOString(),
    userId: 'USR004',
    userName: 'Lisa Wang',
    action: 'System Configuration Changed',
    category: 'CONFIGURATION',
    details: 'Updated password policy: minimum length changed from 8 to 12 characters',
    ipAddress: '192.168.1.15',
    userAgent: 'Firefox/121.0',
    status: 'SUCCESS'
  },
  {
    id: 'LOG004',
    timestamp: new Date(Date.now() - 45 * 60 * 1000).toISOString(),
    userId: 'USR002',
    userName: 'Michael Brown',
    action: 'Failed Login Attempt',
    category: 'SECURITY',
    details: 'Invalid MFA code provided',
    ipAddress: '192.168.1.78',
    userAgent: 'Safari/17.0',
    status: 'FAILED'
  },
  {
    id: 'LOG005',
    timestamp: new Date(Date.now() - 60 * 60 * 1000).toISOString(),
    userId: 'USR001',
    userName: 'Sarah Chen',
    action: 'Integration Connected',
    category: 'INTEGRATION',
    details: 'Successfully connected Workday integration',
    ipAddress: '192.168.1.42',
    userAgent: 'Chrome/120.0.0.0',
    status: 'SUCCESS',
    affectedEntity: 'INT001'
  },
  {
    id: 'LOG006',
    timestamp: new Date(Date.now() - 90 * 60 * 1000).toISOString(),
    userId: 'USR004',
    userName: 'Lisa Wang',
    action: 'Backup Initiated',
    category: 'CONFIGURATION',
    details: 'Manual backup initiated for production database',
    ipAddress: '192.168.1.15',
    userAgent: 'Chrome/120.0.0.0',
    status: 'SUCCESS'
  },
  {
    id: 'LOG007',
    timestamp: new Date(Date.now() - 120 * 60 * 1000).toISOString(),
    userId: 'USR005',
    userName: 'David Kim',
    action: 'Unauthorized Access Attempt',
    category: 'SECURITY',
    details: 'Attempted to access admin panel without proper permissions',
    ipAddress: '192.168.1.99',
    userAgent: 'Chrome/119.0.0.0',
    status: 'FAILED'
  }
];

export const mockSystemConfigurations: SystemConfiguration[] = [
  {
    id: 'CONFIG001',
    category: 'Security',
    setting: 'password.min.length',
    value: 12,
    type: 'NUMBER',
    description: 'Minimum password length required',
    lastModified: new Date(Date.now() - 30 * 60 * 1000).toISOString(),
    modifiedBy: 'Lisa Wang',
    requiresRestart: false,
    isSecret: false
  },
  {
    id: 'CONFIG002',
    category: 'Security',
    setting: 'session.timeout',
    value: 3600,
    type: 'NUMBER',
    description: 'Session timeout in seconds',
    lastModified: '2024-01-15T10:00:00Z',
    modifiedBy: 'System Admin',
    requiresRestart: false,
    isSecret: false
  },
  {
    id: 'CONFIG003',
    category: 'Integration',
    setting: 'workday.sync.enabled',
    value: true,
    type: 'BOOLEAN',
    description: 'Enable automatic Workday synchronization',
    lastModified: '2024-02-01T14:30:00Z',
    modifiedBy: 'Sarah Chen',
    requiresRestart: true,
    isSecret: false
  },
  {
    id: 'CONFIG004',
    category: 'Integration',
    setting: 'workday.api.key',
    value: '••••••••••••••••',
    type: 'STRING',
    description: 'Workday API authentication key',
    lastModified: '2024-02-01T14:35:00Z',
    modifiedBy: 'Sarah Chen',
    requiresRestart: false,
    isSecret: true
  },
  {
    id: 'CONFIG005',
    category: 'Performance',
    setting: 'cache.ttl',
    value: 300,
    type: 'NUMBER',
    description: 'Cache time-to-live in seconds',
    lastModified: '2024-01-20T09:15:00Z',
    modifiedBy: 'System Admin',
    requiresRestart: false,
    isSecret: false
  },
  {
    id: 'CONFIG006',
    category: 'Notifications',
    setting: 'email.smtp.host',
    value: 'smtp.cloudsonmars.com',
    type: 'STRING',
    description: 'SMTP server hostname',
    lastModified: '2024-01-10T11:20:00Z',
    modifiedBy: 'System Admin',
    requiresRestart: true,
    isSecret: false
  }
];

export const mockDataIntegrations: DataIntegration[] = [
  {
    id: 'INT001',
    name: 'Workday HRIS',
    type: 'WORKDAY',
    status: 'ACTIVE',
    endpoint: 'https://api.workday.com/v1/cloudsonmars',
    lastSync: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    nextSync: new Date(Date.now() + 4 * 60 * 60 * 1000).toISOString(),
    syncFrequency: 'HOURLY',
    recordsProcessed: 12456,
    errorCount: 0,
    configuration: {
      tenant: 'cloudsonmars',
      apiVersion: 'v35.0',
      includeInactive: false
    },
    credentials: {
      type: 'OAUTH',
      expiresAt: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString()
    }
  },
  {
    id: 'INT002',
    name: 'SAP SuccessFactors',
    type: 'SAP',
    status: 'ACTIVE',
    endpoint: 'https://api.successfactors.com/odata/v2',
    lastSync: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString(),
    nextSync: new Date(Date.now() + 21 * 60 * 60 * 1000).toISOString(),
    syncFrequency: 'DAILY',
    recordsProcessed: 8234,
    errorCount: 2,
    configuration: {
      companyId: 'CLOUDSMARS',
      dataCenter: 'EU2',
      modules: ['Employee', 'Performance', 'Goals']
    },
    credentials: {
      type: 'API_KEY'
    }
  },
  {
    id: 'INT003',
    name: 'LinkedIn Talent Insights',
    type: 'API',
    status: 'ACTIVE',
    endpoint: 'https://api.linkedin.com/v2/talentInsights',
    lastSync: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
    nextSync: new Date(Date.now() + 6 * 24 * 60 * 60 * 1000).toISOString(),
    syncFrequency: 'WEEKLY',
    recordsProcessed: 3456,
    errorCount: 0,
    configuration: {
      scope: ['market-insights', 'talent-pool'],
      regions: ['EMEA', 'NA']
    },
    credentials: {
      type: 'OAUTH',
      expiresAt: new Date(Date.now() + 60 * 24 * 60 * 60 * 1000).toISOString()
    }
  },
  {
    id: 'INT004',
    name: 'Excel Import - Compensation',
    type: 'EXCEL',
    status: 'INACTIVE',
    lastSync: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    nextSync: '',
    syncFrequency: 'MONTHLY',
    recordsProcessed: 1234,
    errorCount: 0,
    configuration: {
      filePath: '/imports/compensation_2024.xlsx',
      sheetName: 'CompData',
      headerRow: 1
    }
  },
  {
    id: 'INT005',
    name: 'Glassdoor API',
    type: 'API',
    status: 'ERROR',
    endpoint: 'https://api.glassdoor.com/v1/reviews',
    lastSync: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    nextSync: '',
    syncFrequency: 'DAILY',
    recordsProcessed: 0,
    errorCount: 15,
    configuration: {
      employerId: 'cloudsonmars',
      includeRatings: true
    },
    credentials: {
      type: 'API_KEY',
      expiresAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString() // Expired
    }
  }
];

export const mockSecurityPolicies: SecurityPolicy[] = [
  {
    id: 'POL001',
    name: 'Password Policy',
    type: 'PASSWORD',
    enabled: true,
    rules: [
      { key: 'minLength', value: 12, description: 'Minimum password length' },
      { key: 'requireUppercase', value: true, description: 'Require uppercase letters' },
      { key: 'requireNumbers', value: true, description: 'Require numbers' },
      { key: 'requireSpecialChars', value: true, description: 'Require special characters' },
      { key: 'expiryDays', value: 90, description: 'Password expiry in days' },
      { key: 'historyCount', value: 5, description: 'Password history to check' }
    ],
    appliesTo: 'ALL',
    lastUpdated: new Date(Date.now() - 30 * 60 * 1000).toISOString(),
    updatedBy: 'Lisa Wang'
  },
  {
    id: 'POL002',
    name: 'Multi-Factor Authentication',
    type: 'MFA',
    enabled: true,
    rules: [
      { key: 'required', value: true, description: 'MFA required for all users' },
      { key: 'methods', value: ['TOTP', 'SMS', 'EMAIL'], description: 'Allowed MFA methods' },
      { key: 'rememberDevice', value: 30, description: 'Remember device for days' }
    ],
    appliesTo: 'ALL',
    lastUpdated: '2024-01-01T00:00:00Z',
    updatedBy: 'System Admin'
  },
  {
    id: 'POL003',
    name: 'Data Access Policy',
    type: 'DATA_ACCESS',
    enabled: true,
    rules: [
      { key: 'piiAccess', value: 'restricted', description: 'PII access level' },
      { key: 'exportLimit', value: 10000, description: 'Maximum records per export' },
      { key: 'auditAllAccess', value: true, description: 'Audit all data access' }
    ],
    appliesTo: ['MANAGER', 'RECRUITER'],
    lastUpdated: '2024-01-15T10:00:00Z',
    updatedBy: 'Sarah Chen'
  },
  {
    id: 'POL004',
    name: 'API Rate Limiting',
    type: 'API',
    enabled: true,
    rules: [
      { key: 'requestsPerMinute', value: 100, description: 'Max requests per minute' },
      { key: 'requestsPerDay', value: 10000, description: 'Max requests per day' },
      { key: 'burstLimit', value: 20, description: 'Burst limit' }
    ],
    appliesTo: 'ALL',
    lastUpdated: '2024-02-01T14:30:00Z',
    updatedBy: 'System Admin'
  }
];

export const mockSystemHealth: SystemHealth = {
  status: 'HEALTHY',
  uptime: 2592000, // 30 days in seconds
  cpu: 42,
  memory: 68,
  disk: 55,
  activeUsers: 127,
  apiCalls: 45678,
  errorRate: 0.02,
  responseTime: 245, // ms
  services: [
    { name: 'Database', status: 'UP', latency: 12 },
    { name: 'Cache', status: 'UP', latency: 2 },
    { name: 'Workday API', status: 'UP', latency: 450 },
    { name: 'SAP API', status: 'UP', latency: 380 },
    { name: 'Email Service', status: 'UP', latency: 120 },
    { name: 'Glassdoor API', status: 'DEGRADED', latency: 2500 },
    { name: 'Backup Service', status: 'UP', latency: 50 },
    { name: 'ML Pipeline', status: 'UP', latency: 180 }
  ]
};

export const mockBackupConfigurations: BackupConfiguration[] = [
  {
    id: 'BACKUP001',
    name: 'Daily Database Backup',
    type: 'FULL',
    schedule: '0 2 * * *', // 2 AM daily
    destination: 's3://cloudsonmars-backups/database/',
    retention: 30,
    lastBackup: new Date(Date.now() - 20 * 60 * 60 * 1000).toISOString(),
    nextBackup: new Date(Date.now() + 4 * 60 * 60 * 1000).toISOString(),
    status: 'ACTIVE',
    sizeLimit: 100,
    encryptionEnabled: true
  },
  {
    id: 'BACKUP002',
    name: 'Hourly Incremental',
    type: 'INCREMENTAL',
    schedule: '0 * * * *', // Every hour
    destination: 's3://cloudsonmars-backups/incremental/',
    retention: 7,
    lastBackup: new Date(Date.now() - 30 * 60 * 1000).toISOString(),
    nextBackup: new Date(Date.now() + 30 * 60 * 1000).toISOString(),
    status: 'ACTIVE',
    sizeLimit: 10,
    encryptionEnabled: true
  },
  {
    id: 'BACKUP003',
    name: 'Weekly Archive',
    type: 'FULL',
    schedule: '0 3 * * 0', // 3 AM Sunday
    destination: 'azure://backup-archive/weekly/',
    retention: 365,
    lastBackup: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    nextBackup: new Date(Date.now() + 4 * 24 * 60 * 60 * 1000).toISOString(),
    status: 'ACTIVE',
    sizeLimit: 500,
    encryptionEnabled: true
  }
];

export const mockComplianceReports: ComplianceReport[] = [
  {
    id: 'COMP001',
    type: 'GDPR',
    status: 'COMPLIANT',
    lastAudit: '2024-01-15T00:00:00Z',
    nextAudit: '2024-04-15T00:00:00Z',
    findings: [
      {
        severity: 'LOW',
        description: 'Some user consent forms need updating',
        recommendation: 'Update consent forms to include latest data processing activities',
        status: 'IN_PROGRESS'
      }
    ],
    score: 94
  },
  {
    id: 'COMP002',
    type: 'SOC2',
    status: 'COMPLIANT',
    lastAudit: '2024-02-01T00:00:00Z',
    nextAudit: '2024-08-01T00:00:00Z',
    findings: [],
    score: 98
  },
  {
    id: 'COMP003',
    type: 'ISO27001',
    status: 'PENDING_REVIEW',
    lastAudit: '2023-12-01T00:00:00Z',
    nextAudit: '2024-03-01T00:00:00Z',
    findings: [
      {
        severity: 'MEDIUM',
        description: 'Access control procedures need documentation update',
        recommendation: 'Document all access control procedures and approval workflows',
        status: 'OPEN'
      },
      {
        severity: 'LOW',
        description: 'Security awareness training records incomplete',
        recommendation: 'Ensure all employees complete annual security training',
        status: 'IN_PROGRESS'
      }
    ],
    score: 87
  }
];